import { render } from "./FooterComponent.vue?vue&type=template&id=4ede0210"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Felhasznalo\\source\\repos\\favagas-gyor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__